import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { AppConstants } from '../../../../app.constants';
import { RssScrollDirection } from '../../../../core/enums/rss-scroll-direction-enum';
import { RSSArticleMaxAge } from '../../../../core/enums/rss-article-age.enum';
import { RssTickerConfigs } from '../../../../core/models/entities/rss-ticker.type';
import { RSSClockFormat } from '../../../../core/enums/rss-clock-format.enum';
import { RSSClockPlacement } from '../../../../core/enums/rss-clock-placement.enum';

@Component({
  selector: 'modal-configure-rss',
  templateUrl: './modal-configure-rss.component.html',
  styleUrls: ['./modal-configure-rss.component.scss']
})
export class ModalConfigureRssComponent {
  rssConfigs: RssTickerConfigs;
  scrollDirections = RssScrollDirection;
  articleAge = RSSArticleMaxAge;
  clockFormat = RSSClockFormat;
  clockPlacement = RSSClockPlacement;

  maxAgeEnumValues = Object.values(RSSArticleMaxAge);
  isAndroidPlaylist: boolean;

  monitorHeight = AppConstants.RSS_CONFIGS_MONITOR_HEIGHT;
  rssBlockHeight = AppConstants.RSS_CONFIGS_BLOCK_HEIGHT;

  constructor(private dialogRef: MatDialogRef<ModalConfigureRssComponent>) {}

  save(): void {
    this.dialogRef.close(this.rssConfigs);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  onSliderKeyDown(event: KeyboardEvent) {
    const inputEl = event.target as HTMLInputElement;
    const propertyName = inputEl.id;
    const maxValue = inputEl.max;
    let inputValue = inputEl.value.replace(AppConstants.ZERO_NUMBERS_REGULAR, '');

    if (inputValue.match(AppConstants.VALID_NUMBERS_REGULAR)) {
      inputValue = +inputValue > +maxValue ?
        maxValue :
        inputValue;
    } else {
      inputValue = this.rssConfigs[propertyName];
    }

    (event.target as HTMLInputElement).value = inputValue;
    this.rssConfigs[propertyName] = +inputValue;
  }

  onInputFocusOut(event: KeyboardEvent): void {
    const inputEl = event.target as HTMLInputElement;
    const propertyName = inputEl.id;

    this.rssConfigs[propertyName] = this.rssConfigs[propertyName] || +inputEl.min;
  }
}
